import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-checklist',
  templateUrl: './section-checklist.component.html',
  styleUrls: ['./section-checklist.component.css']
})
export class SectionChecklistComponent implements OnInit {

  @Input() sectionInfo;
  
  constructor() { }

  ngOnInit(): void {
  }

}
